export default "__VITE_ASSET__BULsscrO__"